/**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */
var _ol_style_IconAnchorUnits_ = {
  FRACTION: 'fraction',
  PIXELS: 'pixels'
};

export default _ol_style_IconAnchorUnits_;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ol/style/iconanchorunits.js
// module id = ../../../../ol/style/iconanchorunits.js
// module chunks = vendor